import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IAbstractRecord } from '@models';

export const initialValues = {
  addressType: '',
  country: '',
  zone: '',
  city: '',
  street: '',
  building: '',
  addressDetails: '',
  addressDetailsArabic: '',
  isPrimary: false
};

export const getInputs = (
  values: IAbstractRecord = initialValues,
  lovs: Record<string, Record<string, any>> = {},
  isProposal?: boolean
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      addressType: {
        name: 'addressType',
        title: 'Address Type',
        type: FormFieldType.select,
        placeholder: 'Address Type',
        value: values.addressType,
        disabled: false,
        required: true,
        selectOptions: lovs.addressType
      },
      country: {
        name: 'country',
        title: 'Country',
        placeholder: 'Choose Country',
        type: FormFieldType.select,
        value: values.country,
        disabled: false,
        required: true,
        selectOptions: lovs.country
      },
      zone: {
        name: 'zone',
        title: 'Zone',
        placeholder: 'Choose Zone',
        type: FormFieldType.select,
        value: values.zone,
        disabled: false,
        required: false,
        hidden: values.country != 'LB',
        selectOptions: values.country === 'LB' ? lovs.zone : {}
      },
      city: {
        name: 'city',
        title: 'City',
        placeholder: 'City',
        type: FormFieldType.text,
        value: values.city,
        required: true,
        minCharacters: 2,
        maxCharacters: 100
      },
      street: {
        name: 'street',
        title: 'Street',
        placeholder: 'Street',
        type: FormFieldType.text,
        value: values.street,
        required: false,
        minCharacters: 2,
        maxCharacters: 100
      },
      building: {
        name: 'building',
        title: 'Building',
        placeholder: 'Building',
        type: FormFieldType.text,
        value: values.building,
        required: false,
        minCharacters: 2,
        maxCharacters: 100
      },
      addressDetails: {
        name: 'addressDetails',
        title: 'Address Details',
        placeholder: 'Address Details',
        type: FormFieldType.text,
        value: values.addressDetails,
        required: false,
        minCharacters: 2,
        maxCharacters: 100
      },
      addressDetailsArabic: {
        name: 'addressDetailsArabic',
        title: 'Address Details Arabic',
        type: FormFieldType.text,
        placeholder: 'Address Details Arabic',
        value: values.addressDetailsArabic,
        required: false,
        minCharacters: 2,
        maxCharacters: 100
      },
      isPrimary: {
        name: 'isPrimary',
        title: 'Is Primary',
        type: FormFieldType.switch,
        placeholder: 'Is Primary',
        value: values.isPrimary,
        required: false,
        hidden: isProposal,
        tooltipText:
          'Person can have one primary address only; adding this address as primary will make others secondary.'
      }
    }
  }
];
